import { IJSLComponent } from "jsl-render";

export class StatusGarantieComponent implements IJSLComponent {

    public constructor(private form: string) { }

    public render() {
        return <div style="padding:1rem;font-size:1.1rem;z-index:10;position: relative;">
            <p>Vielen Dank für Ihre Angaben und Ihre Registrierung bei unserer Ausgezeichnet-Aktion zur 7er-Serie. Sie erhalten in Kürze eine Mail mit allen weiteren Informationen.</p>
            <p>Ihr NIVONA-Team</p>

            <p><a href={"#" + this.form}>Weitere Maschine registrieren</a></p>

        </div>;
    }

}